export const invertedMessages = {
  'There was a problem loading your shortcuts. Refresh the page to retry.':
    'Nav.ShortcutsWidget.RequestError',
  'Which shortcuts do you need?':
    'Nav.ShortcutsWidget.Personalization.Modal.Title',
  'Get quick access to time-sensitive actions like certification assignments, access requests, password change notices and more. These shortcuts appear as tiles at the top of your homepage and are shown in the order they are selected.':
    'Nav.ShortcutsWidget.Personalization.Modal.Subtitle',
  'There was a problem saving your shortcuts. Refresh the page to retry.':
    'Nav.ShortcutsWidget.Personalization.Modal.SaveError',
  "Shortcut tiles haven't been selected. Add some to your homepage.":
    'Nav.ShortcutsWidget.PromoMessage',
  'No Thanks': 'Nav.ShortcutsWidget.PromoMessage.Reject',
  Saving: 'Nav.ShortcutsWidget.PromoMessage.Saving',
  Clear: 'Nav.ShortcutsWidget.Personalization.Modal.ClearButton',
  'Revert to Default':
    'Nav.ShortcutsWidget.Personalization.Modal.DefaultsButton',
  Save: 'Nav.ShortcutsWidget.Personalization.Modal.SaveButton',
  'There was an error fetching personal shortcuts.':
    'Nav.ShortcutsWidget.Personalization.Modal.FetchError',
  'Loading...': 'Nav.ShortcutsWidget.Personalization.Modal.Loading',
  'You’ve reached the max number of tiles allowed ({count}).':
    'Nav.ShortcutsWidget.Personalization.Modal.MaxReached',
  'Tile Options': 'Nav.ShortcutsWidget.PersonalizationButton',
  'First page': 'Nav.ShortcutsWidget.Aria.FirstPage',
  'Last page': 'Nav.ShortcutsWidget.Aria.LastPage',
} as const;

export const personalizationSectionMessages: Record<string, string> = {
  'Nav.ShortcutsWidget.Personalization.Modal.SectionTitle--request-access':
    'Request Access',
  'Nav.ShortcutsWidget.Personalization.Modal.SectionTitle--view-and-monitor':
    'View & Monitor',
  'Nav.ShortcutsWidget.Personalization.Modal.SectionTitle--manage-and-update':
    'Manage & Update',
  'Nav.ShortcutsWidget.Personalization.Modal.SectionTitle--passwords-and-security':
    'Passwords & Security',
} as const;

export const optionDescriptions: Record<string, string | undefined> = {
  'Nav.ShortcutsWidget.Personalization.Modal.Description--view-saved-requests':
    "See the requests you've saved to continue or duplicate.",
  'Nav.ShortcutsWidget.Personalization.Modal.Description--request-history':
    'See a list of your recent and past access requests.',
  'Nav.ShortcutsWidget.Personalization.Modal.Description--pending-approvals':
    'See the provisioning tasks that are awaiting completion.',
  'Nav.ShortcutsWidget.Personalization.Modal.Description--manage-my-access':
    'Change the applications, accounts and roles you have.',
  'Nav.ShortcutsWidget.Personalization.Modal.Description--manage-delegate':
    'Change which users responsibilities are assigned to.',
  'Nav.ShortcutsWidget.Personalization.Modal.Description--change-account-password-for-self':
    'Update your Saviynt password to maintain security.',
  'Nav.ShortcutsWidget.Personalization.Modal.Description--reset-account-password-for-others':
    'Update the Saviynt password for other users.',
  'Nav.ShortcutsWidget.Personalization.Modal.Description--reset-user-password':
    "Update a user's Saviynt password to maintain security.",
  'Nav.ShortcutsWidget.Personalization.Modal.Description--reset-service-account-password':
    'Update passwords for privileged accounts running tasks.',
  'Nav.ShortcutsWidget.Personalization.Modal.Description--request-emergency-access-IDs':
    'Request temporary-use IDs for highly privileged access.',
  'Nav.ShortcutsWidget.Personalization.Modal.Description--request-emergency-access-roles':
    'Request temporary-use roles for highly privileged access.',
  'Nav.ShortcutsWidget.Personalization.Modal.Description--view-existing-access':
    'See which apps, accounts and more you currently have.',
  'Nav.ShortcutsWidget.Personalization.Modal.Description--pending-tasks':
    'See the provisioning tasks that are awaiting completion.',
  'Nav.ShortcutsWidget.Personalization.Modal.Description--manage-service-accounts':
    'Manage the privileged accounts that run automated tasks.',
  'Nav.ShortcutsWidget.Personalization.Modal.Description--create-new-endpoint':
    "Add a resource that's available for requests.",
  'Nav.ShortcutsWidget.Personalization.Modal.Description--update-existing-endpoint':
    "Change a resource that's available for requests.",
  'Nav.ShortcutsWidget.Personalization.Modal.Description--one-click-disable':
    'Quickly remove all provisioning for a user.',
  'Nav.ShortcutsWidget.Personalization.Modal.Description--create-new-entitlement':
    "Add an entitlement that's available for requests.",
  'Nav.ShortcutsWidget.Personalization.Modal.Description--update-existing-entitlement':
    "Change an entitlement that's available for requests.",
  'Nav.ShortcutsWidget.Personalization.Modal.Description--create-user-request':
    'Request a user to be added to Saviynt.',
  'Nav.ShortcutsWidget.Personalization.Modal.Description--update-user-request':
    'Change a request for a user to be added to Saviynt.',
  'Nav.ShortcutsWidget.Personalization.Modal.Description--custom:start-access-request':
    'Get access to applications, accounts, roles and more.',
  // 'Nav.ShortcutsWidget.Personalization.Modal.Description--create-new-organization':
  //   'TBD',
  // 'Nav.ShortcutsWidget.Personalization.Modal.Description--update-existing-organization':
  //   'TBD',
  // 'Nav.ShortcutsWidget.Personalization.Modal.Description--upload-organization':
  //   'TBD',
  // 'Nav.ShortcutsWidget.Personalization.Modal.Description--upload-user-request':
  //   'TBD',
} as const;
